import { http } from './config/config-receituario'

export default {
  findById: (token, id) => {
    return http.get(`empresas/${id}`, {
      headers: {
        Authorization: token,
      },
    })
  },
  findByName: (token, filters) => {
    return http.get(`empresas/filter`, {
      headers: {
        Authorization: token,
      },
      params: filters,
    })
  },
  listarEmpresa: (token) => {
    return http.get('empresas', {
      headers: {
        Authorization: token,
      },
    })
  },
  salvarEmpresa: (token, empresas) => {
    return http.post('empresas', empresas, {
      headers: {
        Authorization: token,
      },
    })
  },
  atualizarEmpresa(token, empresa) {
    return http.put('empresas/' + empresa.id_empresa_sistema, empresa, {
      headers: {
        Authorization: token,
      },
    })
  },
  deleteEmpresa: (token, id) => {
    return http.delete('empresas/' + id, {
      headers: {
        Authorization: token,
      },
    })
  },
  getMapaEnderecos(token, params) {
    return http.get(`empresas/mapa/enderecos`, {
      headers: { Authorization: token },
      params,
    });
  },
}
